import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { useEffect, useState } from "react";
import { AuthenticationStatus } from "../store/slices/authSlice";
import { useWalletTransactions } from "../hooks/useWalletTransactions";
import { useStream } from "../hooks/useStream";
import { etcRepository } from "../repositories/EtcRepository";
import { authRepository } from "../repositories/AuthRepository";
import { APP_NAME_WITH_WEB } from "../config/app";

export const setAppBadge = (count: number) => {
    document.title = `${count > 0 ? `(${count}) ` : ''}${APP_NAME_WITH_WEB}`;
    const favicon = document.querySelector("link[rel='icon']") as HTMLLinkElement;
    if(favicon) {
        favicon.href = count > 0 ? `/favicon_with_dot.png` : '/favicon.png';
    }
}

export const RedirectHandler = () => {
    const [pathnameToRedirectOnLogin, setPathnameToRedirectOnLogin] = useState('');
    const { status, setCredentialsOnLogin } = useAuth();
    const { nbUnread } = useStream();
    const location = useLocation();
    const navigate = useNavigate();
    const { nbTxUnread } = useWalletTransactions();

    useEffect(() => {
        setAppBadge(nbTxUnread + nbUnread);
    }, [nbTxUnread, nbUnread]);

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const shortLink = urlParams.get('short_link');
        if(shortLink) {
            etcRepository.getDeepLinkInfo(shortLink)
                .then((data) => {
                    switch(data.type) {
                        case 'user':
                            navigate(`/home/chat/user/${data.id}`, { replace: true });
                            return;
                        case 'event':
                            navigate(`/home/search/event/${data.id}`, { replace: true });
                            return;
                        case 'group-chat':
                            navigate(`/home/chat/chat/group/${data.id}?join=true`, { replace: true });
                            return;
                        case 'event-chat':
                            navigate(`/home/chat/chat/event/${data.id}?join=true`, { replace: true });
                            return;
                        case 'event-rsvp':
                            navigate(`/home/search/event/${data.id}`, { replace: true });
                            return;
                    }
                })
                .catch((error) => {
                    console.error('Error fetching deep link info:', error);
                });
        }

        const refreshToken = urlParams.get('refresh_token');
        if(refreshToken) {
            const credentials = {
                accessToken: '',
                refreshToken: refreshToken
            };
            authRepository.refreshToken(credentials)
                .then((data) => {
                    setCredentialsOnLogin(data.credentials, data.pleb);
                    navigate('/home/chat');
                });
        }
    }, [location.search, navigate, setCredentialsOnLogin]);

    useEffect(() => {
        if (
            !location.pathname.startsWith('/login') &&
            status !== AuthenticationStatus.AUTHENTICATED
        ) {
            if (pathnameToRedirectOnLogin === '' && location.pathname.startsWith('/home')) {
                setPathnameToRedirectOnLogin(location.pathname);
            }
            navigate('/login');
            return;
        }

        let shouldRedirect = (
            !location.pathname.startsWith('/home') ||
            location.pathname === '/home' ||
            location.pathname === '/home/'
        ) && status === AuthenticationStatus.AUTHENTICATED;

        if (location.pathname.startsWith('/login') && location.state?.addAccount) {
            shouldRedirect = false;
        }

        if (shouldRedirect) {
            if (pathnameToRedirectOnLogin) {
                navigate(pathnameToRedirectOnLogin);
            } else {
                navigate('/home/chat');
            }
        }
    }, [location, pathnameToRedirectOnLogin, status, navigate]);

  return null;
}
